import {
    REQUEST_REDIRECT,
    FETCH_TEMPLATE_LIST
} from '../ActionTypes'

const INITIAL_STATE = {
    redirectRequest: '',
    templateList: []
}

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case REQUEST_REDIRECT:
            return {...state, redirectRequest: action.payload }
        case FETCH_TEMPLATE_LIST:
            return {...state, templateList: action.payload }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/TemplateListPage/TemplateListPageReducer.js